import { ReactElement } from "react";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ExitToApp, Home } from "@mui/icons-material";
import { useCookies } from "react-cookie";
import { COOKIE_HANBIRO_GW } from "base/constant/cookies";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { configState, DEFAULT_CONFIG_STATE } from "base/store/config";
import { useQueryClient } from "@tanstack/react-query";

interface Props {
  onClickOpenProfileGW: () => void;
}

type ListItemType = {
  text: string;
  icon: ReactElement;
  onClick: () => void;
};

const UserPopupContent = ({ onClickOpenProfileGW }: Props) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [cookies, setCookie, removeCookie] = useCookies();
  const setConfigState = useSetRecoilState(configState);

  const onLogout = () => {
    removeCookie(COOKIE_HANBIRO_GW, {
      path: "/",
    });
    queryClient.removeQueries();
    setConfigState(DEFAULT_CONFIG_STATE);
  };

  const LIST: ListItemType[] = [
    {
      text: t("menu_groupware"),
      icon: <Home />,
      onClick: onClickOpenProfileGW,
    },
    {
      text: t("menu_signout"),
      icon: <ExitToApp />,
      onClick: onLogout,
    },
  ];

  return (
    <List disablePadding>
      {LIST.map((item) => (
        <ListItem key={item.text} disablePadding>
          <ListItemButton onClick={item.onClick}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default UserPopupContent;
